let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6nsC3")).then(() => parcelRequire('9c5wb'));